@if (user) {
  @if (user.email_address) {
    <div
      class="d-block mb-2"
      >
      {{ "EMAIL" | translate }}:
      {{
      user.email_address
      }}
    </div>
  }
  @if (user.okta) {
    @if (!passwordResetted && !user.dealerIsOktaAccount) {
      <button
        class="btn btn-primary btn-block me-2"
        (click)="resetPassword()"
        >
        {{ "RESET_PASSWORD" | translate }}
      </button>
    }
  }
  @if (user.dealerIsOktaAccount) {
    @if (!passwordResetted && accountService.isHelpdesk() && (user.email_address !== '')) {
      <button
        class="btn btn-primary btn-block me-2 reset"
        (click)="resetPassword()"
        >
        {{ "RESET_PASSWORD" | translate }}
      </button>
    }
    @if (
      accountService.isHelpdesk() && !user.linked && (!user.has_idp_account || resetted)
      ) {
      <button
        class="btn btn-primary btn-block me-2 resend"
        (click)="resendNewActivation()"
        >
        {{ "ACTIVATION.RESEND_ACTIVATION" | translate }}
      </button>
    }
    @if (
      accountService.isHelpdesk() && !user.linked && activationResent
      ) {
      <button
        class="btn btn-primary btn-block me-2 getactivation"
        (click)="getActivationLink()"
        >
        {{ "ACTIVATION.GET_ACTIVATION_URL" | translate }}
      </button>
    }
    @if (accountService.isHelpdesk() && user.email_address && user.has_idp_account && !resetted) {
      <button
        class="btn btn-primary btn-block me-2"
        (click)="resetAccount()"
        >
        {{ "ACTIVATION.RESET_ACCOUNT" | translate }}
      </button>
    }
    @if (accountService.isHelpdesk() && user.linked) {
      <button
        class="btn btn-primary btn-block me-2"
        (click)="unlinkAccount()"
        >
        {{ "ACTIVATION.UNLINK_ACCOUNT" | translate }}
      </button>
    }
  }
  @if (passwordResetted) {
    <span class="text-success mt-2">{{
      "PASSWORD_RESETTED" | translate
    }}</span>
  }
  @if (mailSend) {
    <span class="text-success mt-2">{{
      "VERIFY_MAIL_SEND" | translate
    }}</span>
  }
}
